import { Suspense, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { THEME_COMPONENTS } from '@/themes/components';
import { FIXTURE_CONTENT } from '@/themes/fixtures';

export default function ThemePreviewPage() {
  const [params] = useSearchParams();
  const themeId = params.get('theme') ?? '';
  const colorScheme = params.get('colorScheme') ?? 'light';
  const locale = (params.get('locale') ?? 'en') as 'en' | 'pt';

  useEffect(() => {
    const html = document.documentElement;
    const hadDark = html.classList.contains('dark');
    if (colorScheme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
    return () => {
      if (hadDark) {
        html.classList.add('dark');
      } else {
        html.classList.remove('dark');
      }
    };
  }, [colorScheme]);

  const ThemeComponent = THEME_COMPONENTS[themeId];

  if (!ThemeComponent) {
    return (
      <div className="min-h-screen flex items-center justify-center text-theme-text-secondary p-8">
        <p>Theme <code>"{themeId}"</code> not found.</p>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center text-theme-text-secondary">
          Loading…
        </div>
      }
    >
      <ThemeComponent
        {...FIXTURE_CONTENT}
        locale={locale}
        colorScheme={colorScheme as 'light' | 'dark'}
      />
    </Suspense>
  );
}
